import { forwardTo } from "xstate"
import { ECommerceStateNodeConfig } from "./e-commerce-machine"
import { ECommerceContext } from "./e-commerce-machine-context"

export const userEventsConfig = (context: ECommerceContext): ECommerceStateNodeConfig => ({
    invoke: {
        id: "userEvents",
        src: context.flowVersion.stateMachine.userEvents(context),
    },
    on: {
        "*": { actions: forwardTo("userEvents") },
    },
})
